import styled from "styled-components";

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1400px;
  padding: 16px 0;
`;

